import { MessageBox } from "element-ui";
import CryptoJS from 'crypto-js'
import axios from 'axios';

// 获取url中的参数
export function getRequest(text) {
  var url = text;
  var theRequest = {};
  if (url.indexOf('?') !== -1) {
    var str = url.split('?')[1];
    var strs = str.split('&');
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1]);
    }
  }
  return theRequest;
}
// 富文本过滤

export function filterHtml(html) {
	html = html.replace(/\<img/g, '<img style="width:100%;height:auto;display:block;margin:10px 0;"')
	// html = html.replace(/\<iframe/g, '<iframe style="width:750px;height: 421.875px;"')
	// html = html.replace(/\<font/g, '<p>')
	// html = html.replace(/\<\/font\>/g, '</p>')
	return html
}
export function setLocalStorage(key, value) {
  var curtime = new Date().getTime(); // 获取当前时间 ，转换成JSON字符串序列
  var valueDate = JSON.stringify({
    val: value,
    timer: curtime
  });
  try {
    localStorage.setItem(key, valueDate);
  } catch (e) {
    /*if(e.name === 'QUOTA_EXCEEDED_ERR' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
        console.log("Error: 本地存储超过限制");
        localStorage.clear();
    } else {
        console.log("Error: 保存到本地存储失败");
    }*/
    // 兼容性写法
    if (isQuotaExceeded(e)) {
      console.log("Error: 本地存储超过限制");
      localStorage.clear();
    } else {
      console.log("Error: 保存到本地存储失败");
    }
  }
}

function isQuotaExceeded(e) {
  var quotaExceeded = false;
  if (e) {
    if (e.code) {
      switch (e.code) {
        case 22:
          quotaExceeded = true;
          break;
        case 1014: // Firefox
          if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
            quotaExceeded = true;
          }
          break;
      }
    } else if (e.number === -2147024882) { // IE8
      quotaExceeded = true;
    }
  }
  return quotaExceeded;
}

export function getLocalStorage(key) {
  var exp = 1000 * 60 * 60 * 24 * 7;
  if (localStorage.getItem(key)) {
    var vals = localStorage.getItem(key); // 获取本地存储的值
    var dataObj = JSON.parse(vals); // 将字符串转换成JSON对象
    // 如果(当前时间 - 存储的元素在创建时候设置的时间) > 过期时间
    var isTimed = (new Date().getTime() - dataObj.timer) > exp;
    if (isTimed) {
      console.log("存储已过期");
      localStorage.removeItem(key);
      return null;
    } else {
      var newValue = dataObj.val;
    }
    return newValue;
  } else {
    return null;
  }
}

//处理导出流    name  活动名称
export function exportExcelStream(res, name) {
  //创建一个隐藏的a连接
  const link = document.createElement('a');
  let blob = new Blob([res.data], {
    type: 'application/vnd.ms-excel'
  });
  link.style.display = 'none';
  //设置连接
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', name + '.xlsx') // 设置下载文件名称
  document.body.appendChild(link);
  //模拟点击事件
  link.click();
  document.body.removeChild(link)
}

// 防抖函数
export function debounce(fn, delay) {
  let timer;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}
export function isPhone(rule, value, callback) {
  const reg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
  if (value == '' || value == undefined || value == null) {
    callback();
  } else {
    if ((!reg.test(value)) && value != '') {
      callback(new Error('请输入正确的电话号码'));
    } else {
      callback();
    }
  }
}


// 投递二维码弹窗
export function handleSaoMa(text = "使用微信扫一扫，手机继续完成投递", imgUrl = "https://style.81lianpin.com/75y7k29ehv/pc/81lp_ma.jpg") {
  return MessageBox.alert(`
    <div>
      <div style="width: 280px;height: 280px;margin: 0 auto;">
        <img class="img" src="${imgUrl}" />
      </div>
      <div style="width: 280px;text-align: center;margin: 0 auto;color: #000;">${text}</div>
    </div>
    `, {
    dangerouslyUseHTMLString: true,
    showConfirmButton: false,
    closeOnClickModal: true,
    showClose: false
  }).catch(() => { });
}
// 81扫码+扫码提示
export function handleSaoMa2(text = "使用微信扫一扫，手机继续完成投递", imgUrl = "https://style.81lianpin.com/75y7k29ehv/pc/81lp_ma.jpg") {
  return MessageBox.alert(
    `<div>
      <div style="width: 150px;height: 150px;margin: 0 auto;">
        <img class="img" src="${imgUrl}" />
      </div>
      <div style="width: 280px;text-align: center;margin: 0 auto;color: #000;">${text}</div>
      <div style="background-color: #ccc;text-align: right;font-size: 12px;">
        <ul style="list-style: inside;text-align: left;padding-inline-start: 40px;line-height: 1.5;padding-top: 15px;color: #000;">
          <li style="list-style: disc;">求职中如遇招聘方扣押证件、要求提供担保或收取财物、强迫入股或集资、收取不正当利益或其他违法情形，请立即举报。</li>
          <li style="list-style: disc;">如遇岗位要求海外工作，请提高警惕，谨防诈骗</li>
          <li style="list-style: disc;">81联聘禁止发布刷单、刷钻、优惠券推广类信息，求职者因从事此类工作造成经济损失，81联聘不承担任何责任！</li>
        </ul>
        <a href="/userprivacyagreement" target="_blank" style="color: #1f7ec3;text-decoration: underline;margin-right: 12px;"><span>查看详情</span></a>
      </div>
    </div>`, {
    dangerouslyUseHTMLString: true,
    showConfirmButton: false,
    closeOnClickModal: true,
    showClose: false
  }).catch(() => { });
}
// Input 输入数字校验
// 是否可以输入小数 | 非负 | 非负整数 | 整数 | 负数 | 是否可以为负
// 保留小数点几位有效数字？(截取 | 四舍五入 | 其它方法)
// 输入值是否可以有范围限制
/** 
   * @param {type} name
   * @param {String} value Input框输入值
   * @param {Boolean} hasDot 是否可以为小数
   * @param {Boolean | Number} integerLen 整数保留的位数
   * @param {Boolean | Number} decimalLen 小数保留的位数
   * @param {Boolean | Number} negative 是否可以为负数
   * @param {Boolean | Array} range 是否有输入范围
   * @param {Boolean | Number} fixednum 是否四舍五入保留n位有效数字
*/
export function numVerification({value,hasDot = true,integerLen,decimalLen,negative = false,fixednum = false}) {
  if (hasDot) {
    value = negative ? value.replace(/[^\d.-]/g, '') : value.replace(/[^\d.]/g, ''); //先把非数字的都替换掉，除了数字和.
    value = value.replace(/^\./g, ''); //必须保证第一个为数字而不是.
    value = value.replace(/\.{2,}/g, '.'); //保证只有出现一个.而没有多个.
    value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
    if(integerLen || decimalLen) {
      let valueArray = value.split('.');
      let integer = valueArray[0]
      let decimal = valueArray[1]
      if(integerLen) {
        integer = valueArray[0].substring(0, integerLen);
      }
      if(decimalLen) {
        decimal = valueArray[1] ? valueArray[1].substring(0, decimalLen) : '';
      }
      value = decimal ? integer + '.' + decimal : value.indexOf('.') > -1 ? integer + '.' : integer;
      if(fixednum) {
        value = String(parseFloat(value).toFixed(fixednum))
      }
    }
  } else {
    value = negative ?value.replace(/[^\d-]/g, '') : value.replace(/\D/g, '')
  }
  if(integerLen) {
    value = value.substring(0, integerLen);
  }
  // if(value) {
  //   if (min && (min > value)) {
  //     console.log(min);
  //     value = min
  //   }
  //   if (max && (max < value)) value = max
  // }
  return value;
}
export function encrypt(word, keyStr){ //加密
  keyStr = keyStr ? keyStr : '_81lianpin888888';
  var key  = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
  return encrypted.toString();
}
//解密
export function decrypt(word, keyStr){  
  keyStr = keyStr ? keyStr : '_81lianpin888888';
  var key  = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
  var decrypt = CryptoJS.AES.decrypt(word, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}
export function isNewVersion(){  
  let url = `//${window.location.host}/static/version.json?t=${new Date().getTime()}`;
  axios.get(url).then(res => {
      if (res.status === 200) {
          let vueVersion = res.data.version,
          localVueVersion = localStorage.getItem('vueVersion');
          if (localVueVersion != vueVersion) {
            localStorage.setItem('vueVersion', vueVersion);
            window.location.reload();
            return;
          }
      }
  });
}


// WEBPACK FOOTER //
// ./src/utils/public.js